if(document.getElementById('popup-btn')){

var Modal = document.getElementById("popup-content");
var Btn = document.getElementById("popup-btn");
var Body = document.getElementsByTagName("body")[0];
var Close = document.getElementById("closeIpop");

// Функция для показа модального окна
function showPopup() {
    Modal.style.display = "grid";
    Body.classList.add("iPopIsOpen");
    localStorage.setItem("popupShown", "true");
}

// Функция для закрытия модального окна
function closePopup() {
    Modal.style.display = "none";
    Body.classList.remove("iPopIsOpen");
}

// Показываем модальное окно через 15 секунд после загрузки страницы
//setTimeout(showPopup, 15000);


// Проверяем, было ли модальное окно показано ранее
if (localStorage.getItem("popupShown") !== "true") {
    showPopup();
}

// Обработчик нажатия на кнопку
Btn.onclick = showPopup;

// Обработчик нажатия на кнопку закрытия
Close.onclick = closePopup;

// Обработчик для закрытия модального окна при клике вне его
window.onclick = function (event) {
    if (event.target == Modal) {
        closePopup();
    }
}
}



